import {Input} from '@mantine/core';
import {Space} from 'src/design/atoms/Space';
import {renderFieldLabel} from 'src/app/forms/renderFieldLabel';
import React, {useCallback} from 'react';
import {ProjectSelectBox} from 'src/app/databound-elements/ProjectSelectBox';
import type {ISelectOption} from 'src/types/Form';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormProjectSelectorV2Props {
  field: IFormFieldV2;
  value: string | number | null;
  error?: string;
  onChange: (name: string, value: any, displayValue?: string) => void;
}

export const FormProjectSelectorV2 = React.memo<FormProjectSelectorV2Props>(
  ({field, value, error, onChange}: FormProjectSelectorV2Props) => {
    const handleProjectChange = useCallback(
      (option: ISelectOption | null): void => {
        const projectId = option?.id === '' ? null : option?.id;
        onChange(field.name, projectId, option?.label);
      },
      [field.name, onChange]
    );

    return (
      <Input.Wrapper
        data-testid={`form-field-${field.name}`}
        label={renderFieldLabel(field)}
        withAsterisk={field.required}
        error={error}
        description={field.description}>
        <Space mb="xs" />
        <ProjectSelectBox
          onSelectChangeCallback={handleProjectChange}
          label={''}
          value={value === null ? '' : String(value)}
          error={!!error}
          disabled={field.disabled}
          includeInstanceWide={true}
        />
      </Input.Wrapper>
    );
  }
);
